"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BalanceBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _reactivity = require("@vue/reactivity");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Balance Query",
  settings: _variables.BalanceVariable.settings
}, {
  title: "Balance Variable",
  settings: {
    variable: {
      type: "def",
      description: "Optionally save the balance to a new variable.",
      default: {
        name: "balance"
      }
    }
  }
}];
class BalanceBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "balance");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "contractVariable", void 0);
    (0, _defineProperty2.default)(this, "callVariable", void 0);
    this.param = param;
    let refs = (0, _reactivity.toRefs)(param);
    this.contractVariable = this.addBlockVariable(new _variables.PointerVariable(), (0, _reactivity.reactive)({
      ref: refs.contract || {
        type: "var",
        param: {
          type: "contract"
        }
      }
    }));
    let callParams = (0, _reactivity.reactive)({
      contract: refs.contract,
      abi: "balanceOf",
      args: [refs.wallet || {
        type: "var",
        param: {
          type: "wallet"
        }
      }],
      convert: [{
        type: "decimals"
      }],
      updateEvent: "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef"
    });
    this.callVariable = this.addBlockVariable(variableTypes.get("call"), callParams);
  }
  renderValue() {
    let value = this.callVariable.value();
    let contract = this.contractVariable.value();
    if (_variables.VarsContract.isVarsContract(contract === null || contract === void 0 ? void 0 : contract.value)) {
      return new _variables.VarsMetaValue(_variables.vals.stringValue(value), "balance", {
        contract: contract.value
      });
    }
    return new _variables.VarsMetaValue(null, "balance", {
      contract: null
    });
  }
}
exports.BalanceBlock = BalanceBlock;
(0, _defineProperty2.default)(BalanceBlock, "settings", settings);
//# sourceMappingURL=BalanceBlock.js.map